import { supabase } from '../lib/supabase'
import type { AppLocale } from '../i18n/localeStorage'
import { isAppLocale } from '../i18n/localeStorage'

/** Persist preferred_locale for the signed-in user (own row only via RPC). */
export async function savePreferredLocale(locale: AppLocale): Promise<AppLocale> {
  if (!isAppLocale(locale)) {
    throw new Error('invalid_locale')
  }
  const { data, error } = await supabase.rpc('set_my_preferred_locale', {
    p_locale: locale,
  })
  if (error) throw error
  const saved = typeof data === 'string' ? data : locale
  if (!isAppLocale(saved)) return locale
  return saved
}
